import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config/api';

/** Stable cursor pages with an offset fallback for compatible legacy lists. */
export function useHistoryPage(apiCall, path, limit = 50) {
  const [navigation, setNavigation] = useState({ path, cursors: [null] });
  const [responseState, setResponseState] = useState({ path, result: { data: [], total: 0 } });
  // Derive a first page immediately when filters change; never send an old
  // cursor against a new entity/filter while waiting for an effect to reset it.
  const cursors = navigation.path === path ? navigation.cursors : [null];
  const result = responseState.path === path ? responseState.result : { data: [], total: 0 };
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [revision, setRevision] = useState(0);
  const page = cursors.length - 1;
  const cursor = cursors[page];
  useEffect(() => {
    let current = true;
    setLoading(true); setError(null);
    const url = `${API_BASE_URL}${path}${path.includes('?') ? '&' : '?'}limit=${limit}&${cursor ? `cursor=${encodeURIComponent(cursor)}` : `offset=${page * limit}`}`;
    apiCall(url).then(response => {
      if (response?.error) throw new Error(response.error);
      if (current) setResponseState({ path, result: response || { data: [], total: 0 } });
    }).catch(err => { if (current) setError(err.message || 'Could not load history'); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [apiCall, path, limit, page, cursor, revision]);
  return { ...result, data: result.data || [], error, loading, page, limit,
    hasNext: result.next_cursor || (page + 1) * limit < Number(result.total || 0),
    next: () => setNavigation({ path, cursors: [...cursors, result.next_cursor || null] }),
    previous: () => setNavigation({ path, cursors: cursors.length > 1 ? cursors.slice(0, -1) : cursors }),
    reload: () => setRevision(n => n + 1) };
}
